import _ from "lodash";
import Back from "@/components/Back.vue";
import { checkDingHistory, asyncDing, unitAppDetail, getSyncSwitchConfig, configSyncSwitchDingTalk } from "@/service/appList";
export default {
  components: {
    Back
  },
  props: {
    text: String
  },
  data() {
    return {
      time: "",
      detail: {},
      loading: false,
      synchronous: "F"
    };
  },
  computed: {
    _unitId() {
      return this.$store.state.user.userInfo.unitId;
    },
    disabled() {
      return this.synchronous === "F" ? false : true;
    },
    showMessageContent() {
      return this.synchronous === "F" ? $t("h67x2", "手动") : $t("mjum2", "自动");
    }
  },
  methods: {
    async asyncDing() {
      this.loading = true;
      const res = await asyncDing();
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("b1twyw4", "同步成功"));
      }
      this.loading = false;
      await this.show();
    },
    async show() {
      const res = await checkDingHistory();
      if (res.data && res.data.result === 0) {
        this.time = _.first(res.data.retVal);
      }
    },
    async getDetail() {
      const {
        code
      } = this.$route.query;
      const res = await unitAppDetail(code);
      if (res.data && res.data.result == 0) {
        this.detail = res.data.retVal;
      }
      await this.show();
    },
    /*
     ** 获取同步方式
     */
    async getSyncSwitch() {
      const {
        id
      } = this.$route.query;
      const params = {
        appId: id,
        unitId: this._unitId
      };
      const res = await getSyncSwitchConfig(params);
      if (res.data && res.data.result == 0) {
        this.synchronous = res.data.retVal;
      }
    },
    /*
     ** 同步设置
     */
    async onChangesynchronous() {
      const params = {
        appId: this.$route.query.id,
        unitId: this._unitId,
        isAutoSyncEnabled: this.synchronous
      };
      const res = await configSyncSwitchDingTalk(params);
      if (res.data && res.data.result == 0) {
        this.$Message.success(`${$t("ai4tu77", "当前同步方式:")} ` + this.showMessageContent);
      }
    }
  },
  mounted() {
    this.getDetail();
    this.getSyncSwitch();
  }
};